import { useTranslation } from 'next-i18next';
import { PropsWithChildren, memo, useMemo } from 'react';
import { Box } from '@bridebook/ui';
import { IconMagnifier } from '@bridebook/ui/src/icons/dynamic';
import { hasEmptyProperties } from '@bridebook/web/app-shared/lib/utils/has-empty-properties';
import styles from './search-no-results.style';

interface IProps extends PropsWithChildren {
  filters?: Record<string, any>;
  isMobile: boolean;
  category: string;
  isLoggedOut?: boolean;
}

const SearchNoResults = ({ filters = {}, isMobile, category, children, isLoggedOut }: IProps) => {
  const { t } = useTranslation('search');
  const { market, ...filtersWithoutMarket } = filters;
  const noFilters = hasEmptyProperties(filtersWithoutMarket);

  const heading = useMemo(() => {
    if (noFilters) return t('noResults.header.noFilters');

    return t('noResults.header.hasFilters', { category });
  }, [category, noFilters, t]);

  const subHeading = useMemo(() => {
    if (!noFilters) return t('noResults.subHeader.hasFilters', { category });

    if (isLoggedOut) {
      return t('noResults.subHeader.loggedOut.noFilters');
    } else {
      return t('noResults.subHeader.loggedIn.noFilters', { category });
    }
  }, [category, isLoggedOut, noFilters, t]);

  return (
    <Box style={styles.wrapper}>
      <Box style={styles.headingWrapper}>
        <IconMagnifier width={isMobile ? 60 : 100} />
        <Box style={styles.heading}>{heading}</Box>
        {!isMobile && <Box style={styles.subHeading}>{subHeading}</Box>}
      </Box>
      {children}
    </Box>
  );
};

export default memo(SearchNoResults) as typeof SearchNoResults;
